import React from "react";
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image";
import '../../sass/components/flexibleModules/_components.featuredSpeakersSection.scss';

const FeaturedSpeakersSection = ({ data }) => {

    return (
        <div className="cp-featuredSpeakersSection" style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-featuredSpeakersSection__inner" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }}>
                <div className="cp-featuredSpeakersSection__top l--flex">
                    {data.featuredSpeakersHeader &&
                        <h2>{data.featuredSpeakersHeader}</h2>
                    }
                    {data.featuredSpeakersHeaderLink &&
                        <div className="l-relativeButton">
                            <a href={data.featuredSpeakersHeaderLink.url} target={data.featuredSpeakersHeaderLink.target} className="l-button">{data.featuredSpeakersHeaderLink.title}</a>
                            <a href={data.featuredSpeakersHeaderLink.url} target={data.featuredSpeakersHeaderLink.target} className="l-button l-backgroundHover">{data.featuredSpeakersHeaderLink.title}</a>
                        </div>
                    }
                </div>
                <div className="cp-featuredSpeakersSection__middle l--flex">
                    {data.featuredSpeakersSections &&
                        <>
                            {data.featuredSpeakersSections.map((speakerDetail, index) => (
                                <div className="cp-speakerDetails" key={index}>
                                    {speakerDetail.image &&
                                        <GatsbyImage className="l--borderRadiusLarge" image={getImage(speakerDetail.image.gatsbyImage)} alt={speakerDetail.image.altText} />
                                    }
                                    <div className="cp-speakerDetails__content l--flex">
                                        <div className="cp-speakerDetails__content-left">
                                            {speakerDetail.speakerName &&
                                                <h3>{speakerDetail.speakerName}</h3>
                                            }
                                            {speakerDetail.speakerTitle &&
                                                <p>{speakerDetail.speakerTitle}</p>
                                            }
                                        </div>
                                        {speakerDetail.linkedinUrl &&
                                            <a href={speakerDetail.linkedinUrl} target="_blank" rel="noreferrer">
                                                <StaticImage src='../../images/linkedin-blue-v2.svg' alt="LinkedIn" />
                                            </a>
                                        }
                                    </div>
                                </div>
                            ))}
                        </>
                    }
                </div>
                <div className="cp-featuredSpeakersSection__bottom">
                    {data.featuredSpeakersViewAllSpeakersLink &&
                        <a href={data.featuredSpeakersViewAllSpeakersLink.url} target={data.featuredSpeakersViewAllSpeakersLink.target} className="l--textlink">
                            <span>{data.featuredSpeakersViewAllSpeakersLink.title}</span>
                            <StaticImage src='../../images/perform-arrow.svg' alt="View all speakers" />
                        </a>
                    }
                </div>
            </div>
        </div>
    )
}

export default FeaturedSpeakersSection;